package io.horion.cv.models

import io.horion.cv.pages.navigation.Screen

data class NewMenuItemData(
    val label: String,
    val iconSrc: String,
    val route: String
)

val items = listOf(
    NewMenuItemData(
        label    = "Créer un CV",
        iconSrc  = "/letter-cv-icon1.svg",
        route    = Screen.CV.path
    ),
    NewMenuItemData(
        label    = "Créer une lettre de motivation",
        iconSrc  = "/letter-icon1.svg",
        route    = Screen.Motivation.path
    ),
    NewMenuItemData(
        label    = "Ajouter une candidature",
        iconSrc  = "/candidatures-icon1.svg",
        route    = "/candidatures"
    )
)
